class TrinoviHero {
  constructor(el) {
    this.el = el;
    this.slides = el.querySelectorAll('.hero__slide');
    this.dots = el.querySelectorAll('.hero__dot');
    this.current = 0;
    this.timer = null;
    if (this.slides.length < 2) return;
    this.start();
    el.querySelector('.hero__prev')?.addEventListener('click', () => this.go(this.current - 1));
    el.querySelector('.hero__next')?.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
  }
  go(n) {
    this.slides[this.current].classList.remove('active');
    this.dots[this.current]?.classList.remove('active');
    this.current = (n + this.slides.length) % this.slides.length;
    this.slides[this.current].classList.add('active');
    this.dots[this.current]?.classList.add('active');
    this.restart();
  }
  start() { this.timer = setInterval(() => this.go(this.current + 1), 5000); }
  restart() { clearInterval(this.timer); this.start(); }
}
document.querySelectorAll('.trinovi-hero').forEach(el => new TrinoviHero(el));
